var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "BasePage",
      class: [_vm.bemBlock, "the-home"],
      attrs: {
        id: _vm.id,
        "data-page-id": _vm.pageId,
        "data-page-type": _vm.getCustomTypeComponent(_vm.pageData)
      },
      on: { click: _vm.handlerSearchableClick }
    },
    [
      _c(
        "div",
        { class: [_vm.bemElement("modules"), "the-home__modules"] },
        [
          _vm._l(_vm.filteredComponents, function(component, index) {
            return [
              Object.values(_vm.customComponentType).includes(component.type_id)
                ? _c(
                    "div",
                    {
                      key: "component-custom-" + component.id + "-" + index,
                      class: [_vm.bemElement("module"), "the-home-module"]
                    },
                    [
                      component.custom &&
                      component.custom.data &&
                      component.custom.data.styles
                        ? _c("style", {
                            tag: "component",
                            domProps: {
                              innerHTML: _vm._s(component.custom.data.styles)
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      component.type_id === _vm.customComponentType.searchForm
                        ? _c(
                            "TheSearch",
                            _vm._b(
                              {
                                class:
                                  component.custom && component.custom.data
                                    ? [
                                        component.custom.data
                                          .componentBaseClassName,
                                        component.custom.data
                                          .componentClassName,
                                        "base-page-render__module--" +
                                          component.custom.data
                                            .componentClassModifiers
                                      ]
                                    : "",
                                attrs: { bem: "the-search-ai-form" }
                              },
                              "TheSearch",
                              _vm.getCustomDataComponent(
                                component,
                                _vm.searchProp
                              ),
                              false
                            )
                          )
                        : _vm.isCategoryFeatured(component)
                        ? _c(
                            "div",
                            _vm._b(
                              { class: _vm.categoryComponent.className },
                              "div",
                              _vm.getCustomDataComponent(component),
                              false
                            ),
                            [
                              _vm.categoryComponent.title
                                ? _c("div", {
                                    class: _vm.categoryComponent.title.class,
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.categoryComponent.title.html
                                      )
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.categoryComponent.poster
                                ? _c("div", {
                                    class: _vm.categoryComponent.poster.class,
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.categoryComponent.poster.html
                                      )
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.categoryComponent.slider
                                ? _c("BaseProductSlider", {
                                    class: _vm.categoryComponent.slider.class,
                                    attrs: {
                                      products:
                                        _vm.categoryComponent.slider.products,
                                      "tile-context":
                                        _vm.categoryComponent.slider.tileContext
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : component.custom && component.custom.htmlRendered
                ? _c("div", {
                    key: "component-" + component.id + "-" + index,
                    class: [_vm.bemElement("module"), "the-home-module"],
                    domProps: {
                      innerHTML: _vm._s(component.custom.htmlRendered)
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              component.type_id === _vm.customComponentType.searchForm &&
              _vm.getSearchFormLoading
                ? _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isLoadingSearch,
                        expression: "isLoadingSearch"
                      }
                    ],
                    key: "component-loading-" + component.id + "-" + index,
                    class: [
                      _vm.bemElement("loading-search"),
                      "the-home-module",
                      _vm.getSearchFormLoading.className
                    ],
                    domProps: {
                      innerHTML: _vm._s(_vm.getSearchFormLoading.htmlRendered)
                    }
                  })
                : _vm._e()
            ]
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }